var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhitecall1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 384",
    style: {
      enableBackground: "new 0 0 384 384"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:10;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.7,287.3c-9.4-12.1-22-27.5-37-40.9c-17-15.2-31.8-16.4-41.3-14.8c-9.7,1.8-23.8,8-35.3,28.8 c0,0.2-0.2,0.4-0.2,0.4s0,0.2-0.2,0.2c-1-0.4-1.9-0.8-2.9-1.2c-7.4-2.9-14.4-5.7-20.1-9.7c-18.7-13.3-35.1-31.4-53.4-58.5 c-7.8-11.7-12.5-22.8-13.8-33.9c0-0.4,0-0.6-0.2-0.8c6.6-1.4,12.5-5.1,16.4-7.6c20.3-12.9,26.7-32.4,17.5-53.4 c-10.1-23.8-26.3-44.4-47.9-61.4c-11.1-8.8-22.8-4.9-26.5-3.7c-16,5.3-33.1,22.6-43.7,44.2C38.3,95.3,36,115,41.8,131 c8.8,23.8,20.5,45.8,31.8,65.9c32.4,57.5,78.9,105.8,142.5,148.1c11.7,7.8,24.9,15.2,44.6,17.7l1.2,0.2l1.2-0.2 c20.5-1.8,50.3-7,72.3-33.7C345.9,316.5,350.2,304.5,336.7,287.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.5,24.8c77.2,7.6,133.7,76.6,126.1,153.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.3,79.7c48.1,4.7,83.2,47.8,78.5,95.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.6,132c22,2.1,38.2,21.8,36.1,43.9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.5,24.8c77.2,7.6,133.7,76.6,126.1,153.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.3,79.7c48.1,4.7,83.2,47.8,78.5,95.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.6,132c22,2.1,38.2,21.8,36.1,43.9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitecall1);
export default __webpack_public_path__ + "static/media/whitecall1.5bdf8c67e3782936accf3a413f23978f.svg";
export { ForwardRef as ReactComponent };